<template>
  <Day day="20.12.2025">
    <div slot="page-content">
      <h3>Kaja for President 👸</h3>
      <p>
        <img src="@/assets/day20.jpeg"/>
      </p>
    </div>
  </Day>
</template>

<script>
import Day from '../Day.vue'

export default {
  name: 'Day20',
  components: {
    Day
  }
}
</script>
